import { Capacitor } from '@capacitor/core';

const PRODUCTION_URL = 'https://golokdivyanaamkosh.in';

export const getApiUrl = (): string => {
  try {
    if (Capacitor.isNativePlatform()) {
      return PRODUCTION_URL;
    }
  } catch {}
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_URL = getApiUrl();
